import React from "react";
import {
  BsArrowReturnRight,
  BsBookmarkCheckFill,
  BsChevronDoubleDown,
  BsFillTrash3Fill,
  BsPrinter,
  BsViewList,
} from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SelectRecord } from "../redux/vehicleRegistration/VehicleSlice";
import { AiFillEdit } from "react-icons/ai";
import InlineLoadingAnimation from "../shared/InlineLoadingAnimation";
import { DeleteDriverRecord } from "../redux/vehicleRegistration/DeleteDriverRecord";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import { DeleteControlRecord } from "../redux/ControlSection/DeleteControlRecord";
import { AddToControl } from "../redux/vehicleRegistration/AddToControl";
import { FcAcceptDatabase, FcAddDatabase } from "react-icons/fc";
import { t } from "i18next";
import { AddToWaiting } from "../redux/vehicleRegistration/AddToWaiting";
import { AddToApproveBankSlip } from "../redux/vehicleRegistration/AddToApproveBankSlip";
const OptionButton = ({ record, section }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inlineLoading = useSelector((state) => state.delete.loading);
  const selectedDelete = useSelector((state) => state.delete.item);
  const token = useSelector((state) => state.authentication.token);

  const user = useSelector((state) => state.authentication.user);

  // const NavigateControlSection = () => {
  //   // this function will transfer the record to control
  //   // dispatch(AddToControl(token, record.id, "table"));

  //   // this function will transfer the record to waiting
  //   Swal.fire({
  //     title: t("general_key_words.areYouSure"),
  //     text: t("general_key_words.confirmChangeMsg"),
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: t("general_key_words.yesWaiting"),
  //     cancelButtonText: t("general_key_words.cancel"),
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       dispatch(AddToWaiting(token, record.id, "table"));
  //     }
  //   });
  // };


  const NavigateToPrintPage = () => {
    dispatch(SelectRecord(record));
    // window.open('/view-list/view/print', '_blank');
    navigate("/view/print");
  };

  const handleView = () => {
    if (section === "driver") {
      //      navigate(`view/${record.id}`);
      window.open(`/view-list/view/${record.id}`, "_blank");
    } else if (section === "control") {
      window.open(`/control-list/view/${record.id}`, "_blank");
    }
  };

  const handleEdit = () => {
    if (section === "driver") {
      navigate(`/view-list/edit/${record.id}`);
    } else if (section === "control") {
      navigate(`/view-list/edit/${record.id}?driverID=${record.driver.id}`);
    }
  };
  const handleDelete = () => {
    Swal.fire({
      title: t("general_key_words.areYouSure"),
      text: t("general_key_words.deleteConfirmMsg"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("general_key_words.deleteConfirmButtonText"),
      cancelButtonText: t("general_key_words.cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        if (section === "driver") {
          dispatch(DeleteDriverRecord(token, record.id, "table"));
        } else if (section === "control") {
          dispatch(DeleteControlRecord(token, record.id, "table"));
        }
      }
    });
  };

  const NavigateToApproveBankSlip = (type) => {
    // console.log(type)
    Swal.fire({
      title: t("general_key_words.areYouSure"),
      text: t("general_key_words.confirmChangeMsg"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("vehicle_table.yesApproveIt"),
      cancelButtonText: t("general_key_words.cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        // dispatch(AddToApproveBankSlip(token, record.id, "table"));
        dispatch(AddToApproveBankSlip(token, record.id, type));
        // dispatch(AddToWaiting(token, record.id, "table"));
      }
    });
  };

  return selectedDelete === record.id && inlineLoading ? (
    <div className="">
      <InlineLoadingAnimation />
    </div>
  ) : (
    <div className="btn-group"
    
    >
      <button
        className="btn btn-secondary d-flex align-items-center gap-2 rounded"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <BsChevronDoubleDown />
        {t("general_key_words.choose")}
      </button>
      <ul className="dropdown-menu" style={{ zIndex: 2000, color:"blue" }}>
        
        <li>
          <a
            className="dropdown-item d-flex align-items-center gap-2 text-muted"
            type="button"
            onClick={handleView}
          >
            <BsViewList className="bi" />
            {t("general_key_words.view")}
          </a>
        </li>

        <li>
          <a
            className="dropdown-item d-flex align-items-center gap-2 text-muted"
            onClick={NavigateToPrintPage}
            type="button"
          >
            <BsPrinter className="bi" />
            {t("general_key_words.print")}
          </a>
        </li>
        {/* {record.bank_slip_status === "not_approved" ? */}
        {((record.workStatus === "registration" || record.workStatus === "rejected") && record.bank_slip_status === "not_approved") ? 
        (
          <>
          {(user.role==="super" || user.role==="approver") && (
            <li>
              <a
                className="dropdown-item d-flex align-items-center gap-2"
                type="button"
                // onClick={NavigateToApproveBankSlip}
                onClick={()=>{
                  NavigateToApproveBankSlip("approve")
                }}
              >
                {/* <FcAddDatabase /> */}
                <FcAcceptDatabase />
                {/* {t("general_key_words.addToWaitingList")} */}
                {/* {t("general_key_words.approve")}  */}
                {t("vehicle_table.bankSlipApprove")} 
              </a>
            </li>
            )}

            {user.staff !=="traffic staff" && user.role !=="approver" &&(<> 
            <li>
              <a
                className="dropdown-item d-flex align-items-center gap-2 text-muted"
                type="button"
                onClick={handleEdit}
              >
                <AiFillEdit className="bi" />
                {t("general_key_words.edit")}
              </a>
            </li>
            {/* <hr /> */}
            </>
            )}

            {/* <li>
              <a
                className="dropdown-item d-flex align-items-center gap-2 text-danger"
                type="button"
                onClick={handleDelete}
              >
                <BsFillTrash3Fill className="bi" />
                {t("general_key_words.delete")}
              </a>
            </li> */}
            
          </>
        ) : null}

        {/* Reject approved bank slip section: */}
        {((record.workStatus === "registration" || record.workStatus === "rejected")  && record.bank_slip_status === "approved") ? 
        (
          <>
          {(user.role==="super") && (
            <li>
              <a
                className="dropdown-item d-flex align-items-center gap-2"
                type="button"
                onClick={()=>{
                  NavigateToApproveBankSlip("disApprove")
                }}
              >
                <BsArrowReturnRight className="bi" style={{ color: "red" }} />
                {t("general_key_words.bankSlipRejected")} 
              </a>
            </li>
            )}
          </>
        ) : null}

      </ul>
    </div>
  );
};

export default OptionButton;
